import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="nosotros" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">Sobre Nosotros</h2>
            <p className="about-description">
              Somos un equipo apasionado por crear experiencias únicas a través del servicio
              de barras de bebidas. Con años de experiencia en eventos de todo tipo, nos
              especializamos en brindar un servicio profesional, elegante y personalizado.
            </p>
            <p className="about-description">
              Nuestro compromiso es hacer que cada evento sea especial, desde bodas y
              cumpleaños hasta eventos corporativos y fiestas privadas. Trabajamos con
              ingredientes de la más alta calidad y un equipo de bartenders expertos que
              garantizan la excelencia en cada servicio.
            </p>
            <div className="about-features">
              <div className="feature">
                <span className="feature-number">200+</span>
                <span className="feature-label">Eventos Realizados</span>
              </div>
              <div className="feature">
                <span className="feature-number">7+</span>
                <span className="feature-label">Años de Experiencia</span>
              </div>
              <div className="feature">
                <span className="feature-number">100%</span>
                <span className="feature-label">Satisfacción</span>
              </div>
            </div>
          </div>
          <div className="about-image">
          <img
    src="/images/equipo.jpeg"
    alt="Nuestro equipo"
    className="about-img"
  /> 
{/*             <div className="image-placeholder">
              <span>🍾</span>
              <p>Imagen del equipo</p>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
